import "./TimeArticle.scss";

export const TimeArticle = ({ time, style }) => (
  <div className="time" style={style}>
    <div className="time-img" />
    <p className="time-text">{time} минут</p>
  </div>
);
